import styled from 'styled-components'

export const AccountWrap = styled.div`
  display: block;
  width: 100%;
  overflow: auto;
`
